import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-whatsapp',
  imports: [CommonModule,FormsModule],
  templateUrl: './whatsapp.html'
})
export class Whatsapp {
 isOpen = false;
  message = '';

  // 👇 PUT YOUR NUMBER HERE (countrycode + number, no +)
  phone = '917977828078';

    toggle() {
    this.isOpen = !this.isOpen;
  }

  sendWhatsApp() {
    if (!this.message.trim()) return;

    const url =
      'https://wa.me/' +
      this.phone +
      '?text=' +
      encodeURIComponent(this.message);

    window.open(url, '_blank');
  }
}